export const coverWidth = 552;
export const coverHeight = 240;
